  <template>
    <v-row class="mt-4" :no-gutters="$root.isMobile">
      <v-col cols="12" sm="6" v-for="(item, i) in filteredList" :key="i">
        <template-input
          :item="item"
          :toolbar="toolbar"
          :form="form"
          @onAddressLink="onAddressLink"
          @updateForm="updateForm"
          @input="input(item)"
          v-model="item.value"
          @blur="applyCondition(item)"
          :itemName="item.name"
        ></template-input>  
        <div v-if="item.name== 'APPLICABLE ITEM NUMBER(S) (INFORMATION)'"
        class="d-flex align-center success-checkbox-wrapper"
    :class="{ 'success-border': isAdditionalFieldsComplete }"
        >
          <v-checkbox v-model="showModal" label="Additional Fields" dense></v-checkbox>
          <v-icon
      v-if="isAdditionalFieldsComplete"
      color="green"
      small
      class="ml-2"
    >
      mdi-check-circle
    </v-icon>
    
    <v-dialog v-model="showModal" persistent max-width="900px">
      <v-card class="pa-4" outlined>
              <v-card-title
                id="additional_field"
                class="d-flex align-center justify-space-between"
              >
                <span class="headline text-center">Additional Fields</span>

                <v-icon
                  color="grey"
                  size="28"
                  @click="showModal = false"
                >
                  mdi-close-circle
                </v-icon>
              </v-card-title>
              <v-card-text id="dialog-content" >
                <v-row>
                  <v-col cols="12" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="ITEM #"
                      outlined
                      dense
                      readonly
                      v-model="model.item_number"
                      color="purple"
                    />
                  </v-col>
                  <v-col cols="12" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="MFG"
                      outlined
                      dense
                      readonly
                      v-model="model.mfg"
                      class="darkField"
                      />
                  </v-col>
                  <v-col cols="12" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="KEY CATEGORY"
                      outlined
                      dense
                      readonly
                      v-model="model.key_category"
                    />
                  </v-col>
                  <v-col cols="12" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CHIP ID"
                      outlined
                      dense
                      readonly
                      v-model="model.chipId"
                    />
                  </v-col>
                  <v-col cols="12" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="FCC"
                      outlined
                      dense
                      readonly
                      v-model="model.fcc"
                    />
                  </v-col>
                  <v-col cols="12" sm="4" class="py-3">
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        readonly
                        v-model="model.mechanical_key"
                        label="MECHANICAL KEY & INSERT BLADE"
                        class="custom-field"
                      >
                        <template v-slot:append>
                          <div class="vertical-divider" v-if="model.mechanical_key"></div>
                          <span class="emg-key">{{ model.emg_key }}</span>
                        </template>
                      </v-text-field>
                    </v-col>


                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="OEM PART #"
                      outlined
                      dense
                      readonly
                      v-model="model.oem"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IC"
                      outlined
                      dense
                      readonly
                      v-model="model.ic"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CODE SERIES"
                      outlined
                      dense
                      readonly
                      v-model="model.code_series"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="BRAND"
                      outlined
                      dense
                      readonly
                      v-model="model.brand"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CONDITION"
                      outlined
                      dense
                      readonly
                      v-model="model.condition"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="PRICE$"
                      outlined
                      dense
                      readonly
                      v-model="model.price"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="LISHI"
                      outlined
                      dense
                      readonly
                      v-model="model.lishi"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="FREQUENCY"
                      outlined
                      dense
                      readonly
                      v-model="model.frequency"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="TRANSPONDER TYPE"
                      outlined
                      dense
                      readonly
                      v-model="model.transponderType"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="BTN CONFIG"
                      outlined
                      dense
                      readonly
                      v-model="model.btn_config"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="#BUTTONS"
                      outlined
                      dense
                      readonly
                      v-model="model.button"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="BATTERY TYPE"
                      outlined
                      dense
                      readonly
                      v-model="model.battery_type"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="TOTAL TOKENS"
                      outlined
                      dense
                      readonly
                      v-model="model.tokensNeed"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="PIN CODE REQUIRED"
                      outlined
                      dense
                      readonly
                      v-model="model.pinCode"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="RE-FLASHING-(AKL)"
                      outlined
                      dense
                      readonly
                      v-model="model.reFlashing"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="REUSABLE"
                      outlined
                      dense
                      readonly
                      v-model="model.reusable"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CLONEABLE"
                      outlined
                      dense
                      readonly
                      v-model="model.cloneable"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="ADDITIONAL HARDWARE REQUIRED"
                      outlined
                      dense
                      readonly
                      v-model="model.additionalHardware"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="PROGRAM REMOTE"
                      outlined
                      dense
                      readonly
                      v-model="model.programRemote"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="ADD A KEY"
                      outlined
                      dense
                      readonly
                      v-model="model.addKey"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER SYSTEM"
                      outlined
                      dense
                      readonly
                      v-model="model.immobiliserSystem"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER CABLE"
                      outlined
                      dense
                      readonly
                      v-model="model.immobiliserCable"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER SOFTWARE"
                      outlined
                      dense
                      readonly
                      v-model="model.immobiliserSoftware"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="REMOTE SYSTEM"
                      outlined
                      dense
                      readonly
                      v-model="model.remoteSystem"
                    />
                  </v-col>
                  
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="DRAWER"
                      outlined
                      dense
                      readonly
                      v-model="model.drawer"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="SLOT"
                      outlined
                      dense
                      readonly
                      v-model="model.slot"
                    />
                  </v-col>
                  <v-col cols="6" sm="4" class="py-3 d-flex align-center">
                    <!-- <v-btn icon small @click="model.stock = Math.max(1, model.stock - 1)">
                      
                    <v-icon>mdi-minus</v-icon>
                    </v-btn> -->
                    <v-text-field
                      hide-details
                      label="STOCK"
                      outlined
                      dense
                      type="number"
                      readonly
                      v-model.number="model.stock"
                      
                    />

                    <!-- <v-btn icon small @click="model.stock++">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn> -->
                  </v-col>
                  <!-- <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="FREQUENCY"
                      outlined
                      dense
                      readonly
                      v-model="model.frequency"
                    />
                  </v-col> -->
                 
                  <v-col cols="12" sm="6" class="py-3" id="fits-div" >
                    <v-textarea
                      label="FITS"
                      outlined
                      dense
                      v-model="model.fits"
                      class="custom-textarea"
                      readonly
                    ></v-textarea>
                  </v-col>
                  <v-col cols="12" sm="6" class="py-3" id="note-div">
                    <v-textarea
                      label="NOTE"
                      outlined
                      dense
                      v-model="model.notes"
                      class="custom-textarea"
                      readonly
                    ></v-textarea>
                  </v-col>
                  
                </v-row>
                <v-row v-for="(dataEntry, index) in combinedDataEntryLogs.slice(0,10)" :key="index">
                  <h3>
                  {{
                  "" + dataEntry.name +
                  "   |   " + dataEntry.action +
                  "   |   " + new Date(dataEntry.timeStamp).toLocaleDateString('en-US', {timeZone : 'America/Los_Angeles'})
                  + "   |   " + new Date(dataEntry.timeStamp).toLocaleTimeString('en-US', {timeZone : 'America/Los_Angeles'})
                  }}
                  </h3>
                </v-row>
              </v-card-text>

              <v-card-actions>

              </v-card-actions>
              
              <v-card-actions class="justify-end">
                <v-btn
                v-if="!$route.meta.hideAction"
                tile
                depressed
                class="primary"
                :class="$root.isMobile ? 'mt-3' : 'ml-3'"
                :width="$root.isMobile ? '100%' : '140px'"
                @click="sendMail"> Send Mail To
              </v-btn>
                <v-select
                  v-if="!$route.meta.hideAction"
                  hide-details
                  outlined
                  dense
                  label="Technicians Email"
                  :items="listTech"
                  item-text="name"
                  item-value="name"
                  style="width: 180px;"    
                  v-model="technicianName"
                  clearable
                 class="techEMailField"></v-select>

                <v-btn  
                tile
                depressed
                class="danger mr-2 px-10"
                @click="showModal = false; ">
                  Close
                </v-btn>
                <v-btn 
                  
                  @click="generateReport"
                  tile
                  depressed
                  class="primary"
                  >Print as PDF</v-btn>
                
              </v-card-actions>
            </v-card>
            <v-snackbar
             v-model="showToast"
             :timeout="5000"
             :color="toastColor"
             top
             outlined
             right>
              {{ toastMessage }}</v-snackbar>
    </v-dialog>
        </div>
      </v-col>
      
      <v-col cols="12">
        <template>
        <div>
        <vue-html2pdf
  :show-layout="false"
  :float-layout="true"
  :enable-download="false"
  :preview-modal="false"
  :paginate-elements-by-height="1400"
  filename="dynamic-report"
  :pdf-quality="2"
  :manual-pagination="false"
  pdf-format="a3"
  pdf-orientation="portrait"
  pdf-content-width="1100px"
  @progress="onProgress($event)"
  @startPagination="startPaginationHandler()"
  @hasPaginated="hasPaginatedHandler()"
  @beforeDownload="beforeDownloadHandler($event)"
  @hasDownloaded="hasDownloadedHandler($event)"
  ref="html2Pdf"
>
<section slot="pdf-content" class="pdf-content" style="padding-top: 25px; padding-bottom: 40px;">
<!-- Render dynamic content -->
<v-card class="pa-4" outlined>
              <v-card-title class="headline text-center" id="additional_field">
                Additional Fields
              </v-card-title>
              <v-card-text id="dialog-content" >
                <v-row>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="ITEM #"
                      outlined
                      dense
                      readonly
                      v-model="model.item_number"
                      color="purple"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="MFG"
                      outlined
                      dense
                      readonly
                      v-model="model.mfg"
                      class="darkField"
                      />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="KEY CATEGORY"
                      outlined
                      dense
                      readonly
                      v-model="model.key_category"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CHIP ID"
                      outlined
                      dense
                      readonly
                      v-model="model.chipId"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="FCC"
                      outlined
                      dense
                      readonly
                      v-model="model.fcc"
                    />
                  </v-col>
                   <v-col cols="4" class="py-3">
                      <v-text-field
                        hide-details
                        outlined
                        dense
                        readonly
                        v-model="model.mechanical_key"
                        label="MECHANICAL KEY & INSERT BLADE"
                        class="custom-field"
                      >
                        <template v-slot:append>
                          <div class="vertical-divider" v-if="model.mechanical_key != '' || model.emg_key != ''"></div>
                          <span class="emg-key">{{ model.emg_key }}</span>
                        </template>
                      </v-text-field>
                    </v-col>
                  <!-- <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="MECHANICAL AND EMERG. KEY"
                      outlined
                      dense
                      readonly
                      v-model="model.mechanical_key"
                    />
                  </v-col> -->
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="OEM PART #"
                      outlined
                      dense
                      readonly
                      v-model="model.oem"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IC"
                      outlined
                      dense
                      readonly
                      v-model="model.ic"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CODE SERIES"
                      outlined
                      dense
                      readonly
                      v-model="model.code_series"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="BRAND"
                      outlined
                      dense
                      readonly
                      v-model="model.brand"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CONDITION"
                      outlined
                      dense
                      readonly
                      v-model="model.condition"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="PRICE$"
                      outlined
                      dense
                      readonly
                      v-model="model.price"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="LISHI"
                      outlined
                      dense
                      readonly
                      v-model="model.lishi"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="FREQUENCY"
                      outlined
                      dense
                      readonly
                      v-model="model.frequency"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="TRANSPONDER TYPE"
                      outlined
                      dense
                      readonly
                      v-model="model.transponderType"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="BTN CONFIG"
                      outlined
                      dense
                      readonly
                      v-model="model.btn_config"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="#BUTTONS"
                      outlined
                      dense
                      readonly
                      v-model="model.button"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="BATTERY TYPE"
                      outlined
                      dense
                      readonly
                      v-model="model.battery_type"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="TOTAL TOKENS"
                      outlined
                      dense
                      readonly
                      v-model="model.tokensNeed"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="PIN CODE REQUIRED"
                      outlined
                      dense
                      readonly
                      v-model="model.pinCode"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="RE-FLASHING-(AKL)"
                      outlined
                      dense
                      readonly
                      v-model="model.reFlashing"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="REUSABLE"
                      outlined
                      dense
                      readonly
                      v-model="model.reusable"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="CLONEABLE"
                      outlined
                      dense
                      readonly
                      v-model="model.cloneable"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="ADDITIONAL HARDWARE REQUIRED"
                      outlined
                      dense
                      readonly
                      v-model="model.additionalHardware"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="PROGRAM REMOTE"
                      outlined
                      dense
                      readonly
                      v-model="model.programRemote"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="ADD A KEY"
                      outlined
                      dense
                      readonly
                      v-model="model.addKey"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER SYSTEM"
                      outlined
                      dense
                      readonly
                      v-model="model.immobiliserSystem"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER CABLE"
                      outlined
                      dense
                      readonly
                      v-model="model.immobiliserCable"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="IMMOBILISER SOFTWARE"
                      outlined
                      dense
                      readonly
                      v-model="model.immobiliserSoftware"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="REMOTE SYSTEM"
                      outlined
                      dense
                      readonly
                      v-model="model.remoteSystem"
                    />
                  </v-col>
                  
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="DRAWER"
                      outlined
                      dense
                      readonly
                      v-model="model.drawer"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="SLOT"
                      outlined
                      dense
                      readonly
                      v-model="model.slot"
                    />
                  </v-col>
                  <v-col cols="4" class="py-3 d-flex align-center">
                    <!-- <v-btn icon small @click="model.stock = Math.max(1, model.stock - 1)">
                      
                    <v-icon>mdi-minus</v-icon>
                    </v-btn> -->
                    <v-text-field
                      hide-details
                      label="STOCK"
                      outlined
                      dense
                      type="number"
                      readonly
                      v-model.number="model.stock"
                      
                    />

                    <!-- <v-btn icon small @click="model.stock++">
                      <v-icon>mdi-plus</v-icon>
                    </v-btn> -->
                  </v-col>
                  <!-- <v-col cols="4" class="py-3">
                    <v-text-field
                      hide-details
                      label="FREQUENCY"
                      outlined
                      dense
                      readonly
                      v-model="model.frequency"
                    />
                  </v-col> -->
                 
                  <v-col cols="6" class="py-3" id="fits-div" >
                    <div style="flex: 1; border: 1px solid black; padding: 10px;">
                      <strong style="color: #000;">FITS:</strong> <br>
                      <span v-html="model.fits ? model.fits.replace(/\n/g, '<br>') : ''" style="color: #000;"></span>
                    </div>
                  </v-col>
                  <v-col cols="6" class="py-3" id="note-div">
                    <div style="flex: 1; border: 1px solid black; padding: 10px;">
                      <strong style="color: #000;">NOTES:</strong> <br>
                      <span v-html="model.notes ? model.notes.replace(/\n/g, '<br>') : ''" style="color: #000;"></span>
                    </div>
                  </v-col>
                  
                </v-row>
                <v-row v-for="(dataEntry, index) in combinedDataEntryLogs.slice(0,10)" :key="index">
                  <h3>
                  {{
                  "" + dataEntry.name +
                  "   |   " + dataEntry.action +
                  "   |   " + new Date(dataEntry.timeStamp).toLocaleDateString('en-US', {timeZone : 'America/Los_Angeles'})
                  + "   |   " + new Date(dataEntry.timeStamp).toLocaleTimeString('en-US', {timeZone : 'America/Los_Angeles'})
                  }}
                  </h3>
                </v-row>
              </v-card-text>
            </v-card>
<!-- Display the selected image with centering and size adjustments -->

  </section>
        </vue-html2pdf>
</div>
</template>
      </v-col>

    </v-row>
    
  </template>
  
  <script>
  import moment from "moment";
  import TemplateInput from "./TemplateInput.vue";
  import customerModal from "../../../assets/js/customer.modal";
  import { fixed_order } from "../../../assets/js/default";
  import { formatFormula } from "../../../assets/js/customer.helper";
  import { EventBus } from "../../../main";


  import {functions} from "../../../assets/js/firebase";
  import { fetchCombinedDataEntryLogs } from "../../../assets/js/dataEntryLogsService";

 
  import VueHtml2pdf from 'vue-html2pdf';

  const defaultForm = {
    name: "",
  from: "",
  to: "",
  key_category: "",
  app_item_no: "",
  type_of_key: "",
  lostCarKey: 0.00,
  fcc: '',
  code_series: '',
  item_number: '',
  ic: '',
  mechanical_key: ' ',
  emg_key : '',
  mfg: '',
  oem: '',
  drawer: '',
  chipId: '',
  battery_type: '',
  slot: '',
  btn_config: '',
  condition: '',
  stock: 0,
  frequency: '',
  lishi: '',
  button : '',
  onboardProgramming : '',
  fits: '',
  notes : '',
  pinCode : '',
  addKey : '',
  programRemote: '',
  reFlashing : '',
  immobiliserSystem : '',
  tokensNeed : '',
  reusable : '',
  cloneable : '',
  remoteSystem : '',
  immobiliserSoftware : '',
  immobiliserCable : '',
  additionalHardware : '',
  transponderType : '',
  price : '',
  brand : '',
  dataEntry : '',
  dataEntryLogs : [],
};
  export default {
    props: {
      toolbar: {
        type: Object,
        default: () => {
          return {};
        },
      },
      template: {
        type: Object,
        default: () => {
          return {};
        },
      },
      item: {
        type: Object,
        default: () => {
          return {};
        },
      },
      value: {
        type: Object,
        default: () => {
          return {};
        },
      },
    },
    components: { TemplateInput,
      VueHtml2pdf,
     },
    data() {
      return {
        form: {},
        list: [],
        selectedTech : [],
        showModal : false,
        disStatus : true,
        enableDownload : true,
        model : {
          ...defaultForm
        },
        combinedDataEntryLogs: [],
        technicianName : '',
        showToast : false,
        toastColor : 'success',
        toastMessage : '',
              };
    },
    computed: {
      isJobUpdate() {
        return this.$route.name == "job-update";
      },
      orders() {
        let item = this.$store.getters.fieldOrders.find((item) => {
          return item.id == this.id;
        });
        return item != null ? item : {};
      },
      global() {
        return [...this.$store.getters.globalFields].filter(
          (i) => i.id != customerModal.REASON_FOR_CANCELLATION
        );
      },
      service() {
        return this.$store.getters.serviceFields.filter((item) => {
          return item.services && item.services.indexOf(this.id) != -1;
        });
      },
      filteredList() {
        let list = this.list.filter(item => {
          return item.is_estimate_only !== true;
        });

        if (this.visibleFields && this.visibleFields.length > 0) {
          list = list.filter(item => this.visibleFields.includes(item.id));
        }

        return list;
      },
      isUpdate() {
        let { name } = this.$route;
        return name === "customer-update" || name == "job-update";
      },
      isCreate() {
        let { name } = this.$route;
        return name === "customer-create" || name === "quick-look-up";
      },
      id() {
        return this.template.id;
      },
      shouldRerender() {
        return this.$store.state.reRenderOutsideTechnician;
      },
      listTech() {
        return this.$store.getters.technicians
      },
      visibleFields() {
        return this.$store.getters.visibleFields;
      },
      isAdditionalFieldsComplete() {
        return this.model.status;
      },
      isComingFromEstemate() {
      return this.$route.query.autofill === 'true' && this.$route.query.estimateId;
     }
    },
    watch: {
      template() {
        this.init();
      },
      shouldRerender() {
      this.$store.state.reRenderOutsideTechnician;
      // const index = this.list.findIndex(row => row.id == data.id)
      // this.list[index].name = data.name
      
    },
    "model.mechanical_key"(newValue) {
    if (newValue === "") {
      this.model.mechanical_key = " "; // Set to a single space if empty
    }
  },
    },
    methods: {
      getDoc() {
        let doc = {};
        for (let item of this.list) {
          let { value, key } = item;
          if (key != undefined) {
            doc[`${key}`] = value;
          } 
        }
        // let tech = this.form[`${customerModal.OUTSIDE_TECHNICIAN}`];
        // doc[`${customerModal.OUTSIDE_TECHNICIAN}`] = tech;
        
        return doc;
      },
      getCalDoc() {
        let doc = {};
        for (let item of this.list) {
          let { value, key, field_type, options } = item;
          let val = value;
          if (field_type == "select") {
            let data = options.find((item) => {
              return item.name == value;
            });
            val = data != null ? data.value : 0;
          }
          if (field_type == "zipcode") {
            let zipcodes = this.$store.getters.zipcodes;
            let data = zipcodes.find((item) => {
              return item.id == value;
            });
            val = data != null ? data.price : 0;
          }
          doc[`${key}`] = val;
        }
        return doc;
      },
      input(field) {
        const vm = this;
        for (let i = 0; i < vm.list.length; i++) {
          // if (field.value || !field.value) {   // this condition is required for time-of-day field
             let item = vm.list[i];
          if (item.is_calculated == true) {
            let val = vm.calculate(vm.getCalDoc(), item);
            item.value = val;
            vm.$set(vm.list, i, item);
          }     
          // }        
        }
        const makeModel = {
            lostCarKey: this.form[customerModal.LOST_CAR_KEY] || 0,
            carUnlocking: this.form[customerModal.CAR_UNLOCKING] || 0,
        };
        const total = Number(this.form[customerModal.TOTAL] || 0) + 
                Number(makeModel.lostCarKey || 0) + 
                Number(makeModel.carUnlocking || 0);
  
          
        // updating form with the new total and balance due
        this.form[customerModal.TOTAL] = total;
        this.form[customerModal.BALANCE_DUE] = total;
        // this.form[customerModal.OUTSIDE_TECHNICIAN] =""
        let doc = vm.getDoc();
        vm.form = doc;
      
        vm.$emit("input", doc);
        if (field) {
          let isAppointment =
            vm.form[customerModal.ETA].toString().toLowerCase() == "appointment";
          if (field.id == customerModal.ETA && isAppointment) {
            vm.$emit("onAPTSelected");
          }
        }
      },
      applyCondition(item) {
        let list = this.fieldConditions.filter((i) => {
          return i.conditions.find((f) => f.field == item.id);
        });
        for (let condition of list) {
          let passedConditons = condition.conditions
            .map((i) => {
              return this.isConditionPassed(this.form[i.field], i);
            })
            .filter((i) => i === true);
          if (passedConditons.length == condition.conditions.length) {
            condition.perform.forEach((p) => {
              let index = this.list.findIndex((i) => i.id == p.field);
              if (index != -1) {
                this.list[index].value = p.value;
              }
            });
          }
        }
        this.input();
      },
      isConditionPassed(value, and) {
        let isPassed = false;
        switch (and.condition) {
          case "IS EQUAL TO":
            isPassed = value == and.value;
            break;
          case "TIME BETWEEN":
            isPassed = this.isTimeBetween(and.start, and.end, value);
            break;
        }
        return isPassed;
      },
      isTimeBetween(startTime, endTime, currentTime) {
        const startMoment = moment(startTime, "hh:mm a");
        const endMoment = moment(endTime, "hh:mm a");
        const currentMoment = moment(currentTime, "hh:mm a");
        return currentMoment.isBetween(startMoment, endMoment, undefined, "[]");
      },
      calculate(form, item) {
        let cal = 0;
        const vm = this;
        let formula = formatFormula(item, form, {});
        var FormulaParser = require("hot-formula-parser").Parser;
        var parser = new FormulaParser();
        let val = parser.parse(formula);
        if (val.error == null) {
          cal = val.result;
        }
        if (item.key != customerModal.TAX && item.key != customerModal.TAXABLE_AMOUNT 
        && item.key != customerModal.BALANCE_DUE && item.key != customerModal.CREDIT_CARD_CONVENIENCE_FEE) { // last one is for credit card convenience fee
          const lostCarKeyValue = Number(vm.form[customerModal.LOST_CAR_KEY]) || 0;
          const unlockingValue = Number(vm.form[customerModal.CAR_UNLOCKING]) || 0;
          cal += lostCarKeyValue + unlockingValue;
        }
        if (item.key === customerModal.TOTAL) {
          cal = vm.calculateCard(vm.getDoc(), cal);
        }
        return cal.toFixed(2);
      },
      initCustomerSelect({ fields }) {
        const vm = this;
        vm.list.forEach((item, i) => {
          let isNotReason = item.id != customerModal.REASON_FOR_CANCELLATION;
          if (item.is_calculated != true && isNotReason) {
            if (
              fields[item.key] != undefined &&
              item.key !== customerModal.CALL_AT
            ) {
              item.value = fields[item.key];
              vm.$set(vm.list, i, item);
            }
          }
        });
      },
      onCMPSelect(doc) {
        const vm = this;
        if (doc instanceof Object == false) return;
        
        let { address, landmark, zipcode, map_link } = doc;
        vm.list.forEach((item, i) => {
          if (item.key == customerModal.ADDRESSS) {
            item.value = address;
            vm.$set(vm.list, i, item);
          }
          if (item.key == customerModal.LANDMARK) {
            item.value = landmark;
            vm.$set(vm.list, i, item);
          }
          if (item.key == customerModal.ZIPCODE) {
            item.value = zipcode;
            vm.$set(vm.list, i, item);
          }
          if (item.key == customerModal.MAP_LINK) {
            item.value = map_link;
            vm.$set(vm.list, i, item);
          }
        });
      },
      calculateCard(doc, val) {
        const vm = this;
        let percentage = 0;
        let how = doc[customerModal.HOW_PAID];
        let how_paid = vm.global.find((item) => {
          return item.id == customerModal.HOW_PAID;
        });
        if (how_paid instanceof Object && how_paid.options instanceof Object) {
          let how_paid_value = how_paid.options.find((item) => {
            return item.name == how;
          });
          percentage = 0;
          if (how_paid_value != null) {
            percentage = Number(how_paid_value.value);
          }
          if (isNaN(percentage) || !percentage) percentage = 0;
          percentage = percentage / 100;
          percentage = Number(val) * percentage;
        }
        return val + Number(percentage);
      },
      getDefaultValue({ default_field }) {
        let id = this.id;
        let val = "";
        if (typeof default_field == "object") {
          let { type, service, global } = default_field;
          if (type == "global") {
            val = global;
          } else {
            if (typeof service == "object" && service[id] !== undefined) {
              val = service[id];
            }
          }
          
        }
        return val;
      },
      onAddressLink(url) {
        const vm = this;
        vm.list.forEach((item, i) => {
          if (item.key == customerModal.MAP_LINK) {
            item.value = url;
            vm.$set(vm.list, i, item);
          }
        });
      },
      updateForm(value) {
        const vm = this;
        vm.list.forEach((item, i) => {
          if (value[item.key] != undefined) {
            item.value = value[item.key];
            vm.$set(vm.list, i, item);
          }
        });
       
        if (customerModal.TYPE_OF_KEY in value) {
          let item = this.$store.getters.serviceFields.find(
            (i) => i.id == customerModal.TYPE_OF_KEY
          );
          if (item) {
            this.applyCondition(item);
          }
        }
        this.input();
      },
      getEmpty(orders) {
        let list = [];
        Object.keys(orders).forEach((id) => {
          if (id.startsWith("empty-space-")) {
            list.push({
              name: "Empty Space",
              id,
              index: orders[id],
            });
          }
        });
        return list;
      },
      onTechnicianSelected(technician) {
        
        const tech = technician.name.split(' ')[0];
        this.$set(this.form, customerModal.OUTSIDE_TECHNICIAN, tech);
        this.input();
    },
      init() {
        const vm = this;
        vm.model = {
          ...defaultForm
        };
        let { id } = vm;
        vm.list = [];
        if (!id) return;
        let { global, service, orders } = vm;
        let { fields } = vm.item;
        // const outsideTechnicians = this.service.filter((it em) => item.id == customerModal.OUTSIDE_TECHNICIAN).options;
        
        if (fields instanceof Object == false) fields = {};
        let removedFields = vm.isJobUpdate
          ? [...vm.$store.getters.removedFields]
          : [];
        if (vm.isJobUpdate) {
          removedFields = removedFields.filter((i) => {
            return (vm.item.fields || {})[i.id] != undefined;
          });
        }
        let globalRemovedFields = removedFields.filter((i) => i.type == "global");
        let serviceRemovedFields = removedFields.filter(
          (i) => i.type == "service"
        );
       
        let list = [...global, ...globalRemovedFields].map((item) => {
          let key = item.id;
          let index = orders[key];
          if (index == undefined) index = 900;
          if (fixed_order[key] != undefined) index = fixed_order[key];
          let value = "";
          if (fields[key] != undefined) {
            value = fields[key];
          } else {
            value = vm.getDefaultValue(item);
          }
          if (key == customerModal.CALL_AT && vm.isCreate) {
            value = moment().format("hh:mm A");
          }
          item.value = value;
          item.key = key;
          item.index = index;
          return item;
        });
        list = list.concat(
          [...service, ...serviceRemovedFields].map((item) => {
            let key = item.id;
            let index = orders[key];
            if (index == undefined) index = 900;
            if (fixed_order[key] != undefined) index = fixed_order[key];
            item.index = index;
            let value = "";
            if (fields[key] != undefined) {
              value = fields[key];
            } else {
              value = vm.getDefaultValue(item);
            }
            // if (key == customerModal.OUTSIDE_TECHNICIAN) {
            //   value = "ASK JOE"
            // }
            if (key == customerModal.WHAT_IS_TODAY && vm.isCreate) {
              let day = moment().format("ddd");
              if (["Sat", "Sun"].indexOf(day) != -1) {
                let option = (item.options || []).find(
                  (i) => i.name.toLowerCase().indexOf("saturday") != -1
                );
                if (option != null) {
                  value = option.value;
                }
              } else {
                let option = (item.options || []).find(
                  (i) => i.name.toLowerCase().indexOf("monday") != -1
                );
                if (option != null) {
                  value = option.value;
                }
              }
            }
            item.value = value;
            item.key = key;
            return item;
          })
        );
        list = list.concat(vm.getEmpty(orders));
        // list = list.concant(`${}`);
        list = list.sort((a, b) => {
          return a.index - b.index;
        });
        vm.list = list.map((item) => {
          return item;
        });
        let make = list.find((i) => i.id == customerModal.MAKE);
        if (make) this.$emit("autoJob");
        this.input();
        if(vm.isCreate && !vm.isComingFromEstemate){
          let whatIsToday = list.find((i) => i.id == customerModal.WHAT_IS_TODAY);
          if (whatIsToday) this.applyCondition(whatIsToday);
        }
        // const a = vm.list.filter((item) => item.key == customerModal.OUTSIDE_TECHNICIAN);
        
      },
      setDialogData(dialogData) {
        if(!dialogData.dataEntryLogs) {
          dialogData.dataEntryLogs = [];
        }
        let keysOfAdditionalFields = Object.keys(dialogData);

        if(keysOfAdditionalFields.includes('stock')) {
          this.model = {
            ...dialogData
          }
          fetchCombinedDataEntryLogs(this.model).then((logs) => {
            this.combinedDataEntryLogs = logs;
          });
        }
      },
    sendMail : function() {
      
      this.enableDownload = false;
      this.$refs.html2Pdf
      .generatePdf()
      },
      

      generateReport(event) {
        event.preventDefault();
      this.$refs.html2Pdf.generatePdf();

  },
  
  // Event handler for PDF generation progress
  onProgress(event) {
console.log("Progress:", event);
  },
  
  // Event handler when pagination starts
  startPaginationHandler() {
console.log("Pagination started");
  },
  
  // Event handler after pagination is complete
  hasPaginatedHandler() {
console.log("Pagination completed");
  },
  
  // Event handler before downloading the PDF
  async beforeDownloadHandler({ html2pdf, options, pdfContent }) {
    const vm = this;

    const technicianEmail = vm.listTech.find(tech => tech.name == vm.technicianName)?.email;

    const emailDetails = {
            email: technicianEmail, // Replace with the recipient's email
            fileName: "dialog-content.pdf",
          }
    if(!this.enableDownload) {
      
      if(emailDetails.email == null) {
        vm.$set(vm,'toastColor', 'red')
        vm.$set(vm,'toastMessage', `Email for technician ${vm.technicianName} has not been set`)
        vm.$set(vm,'showToast',true);
        setTimeout(() => {
          vm.$set(vm,'showToast',false);
        },5000)
        return ;
      }
      await html2pdf().set(options).from(pdfContent).toPdf().output("blob") // Get PDF as Blob
    .then(async (pdfBlob) => {
      try {
        
        // Convert Blob to Base64 (Firebase Callable functions don't support direct Blob/File upload)
        const reader = new FileReader();
        reader.readAsDataURL(pdfBlob);
        reader.onloadend = async function () {
          const base64data = reader.result.split(",")[1]; // Get base64 string only
          emailDetails.pdfFile = base64data;
          const sendPdfViaMail = functions.httpsCallable("sendFileTech");
          const response = await sendPdfViaMail(emailDetails);

          console.log("PDF sent successfully:", response.data);
          //let technicianInfo = vm.listTech.find( tech => tech.email === technicianEmail);
          vm.toastMessage = `Pdf has been sent on mail to ${vm.technicianName}`;
          vm.$set(vm,'toastColor', 'success')
          vm.$set(vm,'showToast', true)
          setTimeout(() => {
            vm.showToast = false;
          }, 5000);

        };
      } catch (error) {
        console.error("Error sending PDF:", error);
      }});
            
            this.enableDownload = true;
    } else {
      await html2pdf().set(options).from(pdfContent).toPdf().get('pdf').then((pdf) => {
                const totalPages = pdf.internal.getNumberOfPages()
                for (let i = 1; i <= totalPages; i++) {
                    pdf.setPage(i)
                    pdf.setFontSize(10)
                    pdf.setTextColor(150)
                    pdf.text('Page ' + i + ' of ' + totalPages, (pdf.internal.pageSize.getWidth() * 0.88), (pdf.internal.pageSize.getHeight() - 0.3))
                } 
            }).save()
            
    }

  },
  
  // Event handler after the PDF has been downloaded
  hasDownloadedHandler(pdfBlob1) {
  console.log("PDF Downloaded:", pdfBlob1);
},

changePaymentType(data) {
 if(data.toLowerCase() == 'cash') {
  this.list.forEach((item) => {
    if(item.id == customerModal.HOW_PAID) {
      console.log(item);
      this.$set(item, 'value', 'Cash'); // Reactive update
    }
    
  });
 } else {
  this.list.forEach((item) => {
    if(item.id == customerModal.HOW_PAID) {
      console.log(item);
      this.$set(item, 'value', 'Credit/Debit'); // Reactive update
    }
    
  });
 }
 this.input();
    EventBus.$emit('changeCashStatus');
  
},
  
  
    

    },
    mounted() { 
      this.init();
      EventBus.$on('dialog_data',this.setDialogData)
      EventBus.$on('changePaymentType',this.changePaymentType);
    },
  };
  </script>
  <style>
 .custom-field {
  display: flex;
  align-items: center;
}

.custom-field label{
  max-width: 200% !important; 
  overflow: visible !important;
  left: -3px !important
}


.custom-field .v-input__append-inner{
  width: 100%;
  height: 24px;
}

.vertical-divider {
  width: 1px !important;
  background-color: black; /* Vertical line */
  margin: 0 10px; /* Spacing */
  height: 32px;
}

.emg-key {
  color: rgba(0, 0, 0, 1); /* Match default text color */
  font-size: 16px; /* Adjust as needed */
  display: flex;
  align-items: center;
  font-weight: 400;
}



  
  .v-input label{
   color: black !important;
  }

  .v-input label, .v-input input, .v-input fieldset, .v-input textarea{
   color: black !important;
  }

  .techEMailField .v-input__slot{
    width: 180px;
    margin-left: 16px;
  }
  .success-checkbox-wrapper {
  border: 1px solid #111010;
  padding: 10px 8px;
  height: 46px;
  box-sizing: border-box;
}

.success-border {
  border-color: #4CAF50 !important;
  background-color: #E8F5E9;
}
  </style>
